/* Keep Judge.me product destinations in the shopping tab, including newly loaded reviews. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.linksReady) return;
    root.dataset.linksReady = 'true';
    const updateLinks = () => root.querySelectorAll('.jdgm-rev__prod-link[target]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && url.pathname.includes('/products/')) {
        link.removeAttribute('target');
        if (link.getAttribute('aria-describedby') === 'a11y-new-window-message') link.removeAttribute('aria-describedby');
      }
    });
    updateLinks();
    new MutationObserver(updateLinks).observe(root, { childList: true, subtree: true });
  };
  document.querySelectorAll('[data-s2t-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-s2t-reviews]')));
})();
